<div class="shopify-products-section">
  <div class="section-header">
    <h2>{{ 'HOME.SHOPIFY_PRODUCTS.TITLE' | translate }}</h2>
    <p class="section-subtitle">{{ 'HOME.SHOPIFY_PRODUCTS.SUBTITLE' | translate }}</p>
  </div>

  <!-- Search Bar -->
  <div class="search-container">
    <div class="search-input-wrapper">
      <img loading="lazy" src="../../../assets/images/search.svg" alt="Search" class="search-icon">
      <input
        type="text"
        class="search-input"
        [(ngModel)]="searchQuery"
        (input)="onSearchChange()"
        [placeholder]="'HOME.SHOPIFY_PRODUCTS.SEARCH_PLACEHOLDER' | translate">
    </div>
  </div>

  <!-- Loading State -->
  @if (isLoading) {
    <div class="loading-container">
      <div class="products-grid">
        @for (i of [1,2,3,4,5,6]; track i) {
          <div class="product-card skeleton">
            <div class="skeleton-image"></div>
            <div class="skeleton-title"></div>
            <div class="skeleton-price"></div>
            <div class="skeleton-button"></div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Error State -->
  @if (loadError && !isLoading) {
    <div class="error-container">
      <p>{{ 'HOME.SHOPIFY_PRODUCTS.LOAD_ERROR' | translate }}</p>
    </div>
  }

  <!-- Products Grid -->
  @if (!isLoading && !loadError) {
    <div class="products-container">
      <!-- No Results -->
      @if (filteredProducts.length === 0) {
        <div class="no-results">
          <p>{{ 'HOME.SHOPIFY_PRODUCTS.NO_RESULTS' | translate }}</p>
        </div>
      }
      <!-- Products Grid -->
      @if (displayedProducts.length > 0) {
        <div class="products-grid">
          @for (product of displayedProducts; track product) {
            <div class="product-card">
              <div class="product-image-container">
                <div class="image-loader"></div>
                <img [src]="product.imageUrl" [alt]="product.title" class="product-image" loading="eager" (load)="onImageLoad($event)" (error)="onImageError($event)">
                @if (hasDiscount(product)) {
                  <div class="discount-badge">
                    -{{ getDiscountPercentage(product) }}%
                  </div>
                }
              </div>
              <div class="product-info">
                <h3 class="product-title">{{ product.title }}</h3>
                <div class="product-pricing">
                  <span class="product-price">{{ formatPrice(product.price.amount, product.price.currencyCode) }}</span>
                  @if (hasDiscount(product)) {
                    <span class="product-compare-price">
                      {{ formatPrice(product.compareAtPrice!.amount, product.compareAtPrice!.currencyCode) }}
                    </span>
                  }
                </div>
                <button class="add-to-cart-btn" (click)="addToCart(product)">
                  {{ 'HOME.SHOPIFY_PRODUCTS.ADD_TO_CART' | translate }}
                </button>
              </div>
            </div>
          }
        </div>
      }
      <!-- See All Button -->
      @if (hasMore) {
        <div class="load-more-container">
          <a routerLink="/home/magnets" class="show-all-btn">{{ 'HOME.SHOPIFY_PRODUCTS.SHOW_ALL' | translate }}</a>
        </div>
      }
    </div>
  }

  <!-- Added to Cart Notification -->
  <div class="cart-notification" [class.show]="showAddedToCartNotification">
    <div class="cart-notification-content">
      <img loading="lazy" src="../../../assets/images/CheckCircle.svg" alt="Success" class="notification-icon">
      <div class="notification-text">
        <strong>{{ addedProductName }}</strong>
        <span>{{ 'HOME.SHOPIFY_PRODUCTS.ADDED_TO_CART' | translate }}</span>
      </div>
    </div>
  </div>
</div>
